import { forwardRef } from 'react';
import WxPayRefundOrderBase from './WxPayRefundOrderBase';
import WxPayRefundOrderBakEdit from './WxPayRefundOrderBakEdit';

const WxPayRefundOrder = forwardRef<any, any>((props, ref) => (
    <WxPayRefundOrderBase
        ref={ref}                              // ← 把外部 ref 透传给 Base
        apiId="wxPayRefundOrder"
        titleName="微信退款单备份"
        WxPayRefundOrderEditComponent={WxPayRefundOrderBakEdit}
        outerProps={props}
    />
));

export default WxPayRefundOrder;